import { AuthService } from './api/AuthService';
import { CognitoAuthService } from './impl/CognitoAuthService';

export const auth: AuthService = new CognitoAuthService();
